//@flow
import React, { useState } from "react";
// $FlowFixMe
import css from "./listenagain.module.scss";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faChevronCircleRight } from "@fortawesome/free-solid-svg-icons";
import Heading from "../heading";
import Show from "./show";
import { useQuery, gql } from "@apollo/client";

const QUERY_FEATURES = gql`
  query GetFeatures {
    features(onListenAgain: true, withEpisodes: true, latest: 20) {
      name
      description
      image
      episodes{
        id airDate durationSecs description hlsURL audioRcid
      }
      station{
        id themeColour
      }
      sponsor {
        url
        image
        name
      }
    }
  }
`;

// type Props = {
//   // shows: Array<Object>,
// };

// type State = {
//   displayList: number,
// };

const ListenAgain = (props: Object): Object => {
  const [displayList, setDisplayList] = useState(-1);
  const { loading, error, data } = useQuery(QUERY_FEATURES);
  // console.log("EPS", data);
  if (error) console.error(error);
  if (loading || error) return null;
  const handleDisplayEpisodeList = (i: number): void => {
    if (i === displayList) i = -1;
    setDisplayList(i);
  };

  //   if (!showdata) return null;
  const shows = data?.features?.map((show, i) => <Show key={i} displayEpisodes={displayList === i} show={show} onClick={() => handleDisplayEpisodeList(i)} />);
    if (!shows) return null;

    return (
      <div className={css.listenAgain}>
        <Heading colour={data?.features && data.features[0]?.station?.themeColour} title="Latest Shows">Listen again to the most up-to-date shows & podcasts from In Demand</Heading>
        <div className={css.showList}>{shows}</div>
      </div>
    );
};
export default ListenAgain;
